<template>
  <header
    ref="header"
    id="site-header"
    class="site-header"
    :class="[{ open: isOpen}, { sticky: hasSticky}, { black: hasStickyBlack}, { 'is-proj-detail' : isProjectDetail }, isHome ? 'is-home' : 'is-internal']"
  >
    <div class="inner content-max-width flex">
      <a href="/home" class="logo">
        <img
          v-if="hasStickyBlack == false && isHome || isProjectDetail"
          src="/images/logo.svg"
          alt="Canam Logo"
        />
        <img
          v-else
          src="/images/logo-dark.svg"
          alt="Canam Logo Dark"
        />
      </a>

      <nav>
        <ul>
          <li>
            <a href="/">Home</a>
          </li>

          <li
            class="has-sub"
            :class="{ 'active' : subActive }"
            @click="subActive = !subActive"
          >
            <a href="#">What we do</a>
            <div class="subnavs">
              <a v-for="(link, index) of data.wwdp" :key="index" :href="link.url">{{ link.title }}</a>
            </div>
          </li>
          <li v-for="(link, index) of data.nav1" :key="index">
            <a :href="link.url">{{ link.title }}</a>
          </li>
        </ul>
        <ul>
          <li v-for="(link, index) of data.nav2" :key="index">
            <a :href="link.url">{{ link.title }}</a>
          </li>
          <li class="icons flex">
            <a v-for="(item, index) of social" :key="index" :href="item.url">
              <img :src="item.icon" alt="" />
            </a>
          </li>
        </ul>
      </nav>

      <div class="hamburger" @click="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: ["csrf", "data", "logged_in","social"],

  data () {
    return {
      isOpen: false,
      subActive: false,
      hasStickyBlack: false,
      hasSticky: false,
    };
  },

    mounted(){
        window.addEventListener('scroll', this.checkSticky);

    },

  methods: {
    toggleMenu() {

      if (this.$refs.header.classList.contains('sticky')) {
          this.hasSticky = true;
      }

      this.isOpen = !this.isOpen;

      document.querySelector("body").classList.toggle("overflow-hidden");

    },

    toHref(string) {
      return string.split(" ").join("-");
    },

    checkSticky() {
        if (this.$refs.header.classList.contains('black')) {
            this.hasStickyBlack = true;
        }
        else {
            this.hasStickyBlack = false;
        }

        if (this.$refs.header.classList.contains('sticky')) {
            this.hasSticky = true;
        }
        else {
            this.hasSticky = false;
        }

    },

    logout() {
      window.axios
        .post("/logout", { token: this.csrf })
        .then((response) => {
          window.location.href = "/";
        })
        .catch((error) => {});
    }
  },


  computed: {
    isHome () {
      const pathArray = window.location.pathname.split("/")

      if (pathArray.includes("home") || pathArray[1] == "") {
        return true
      }
      return false
    },

    isProjectDetail () {
      const pathArray = window.location.pathname.split("/")
      console.log(pathArray)
      if (!pathArray.includes("project-detail")) {
        return false
      }
      return true
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue